module.exports = __webpack_public_path__ + "public/img/logo_vertical_clustervet.0a327bba.svg";